import { Card } from "react-bootstrap";
import "./style.css";

const EnglishTerms = () => {
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          marginTop: "-1rem",
        }}
        className="padding bg-green-light-cu pt-5"
      >
        <p className="text-center text-green" style={{ fontWeight: "500" }}>
          Last updated:
          <span style={{ fontWeight: "400" }}> October 2025</span>
        </p>

        <h1 className="text-center text-green">Terms and Conditions</h1>

        <p className="text-center">
          By contracting the services of{" "}
          <span style={{ fontWeight: "600" }}>carrosacentroamerica.com</span> in
          written, telephone or oral manner will be governed by the following
          agreement and/or Terms & Conditions.
        </p>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>1. DEFINITION AND SCOPE</h4>
          <p>
            GARLAS LLC acts as an authorized logistics agent and broker to
            coordinate land and ocean transportation of vehicles, motorcycles,
            boats, and vessels within the United States, to and from Puerto
            Rico, and to Central America (Guatemala, Honduras, and El Salvador).
            GARLAS is not a direct carrier but a licensed logistics intermediary
            (broker) registered with the DOT and FMCSA.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>2. SERVICES AND LIMITATION OF LIABILITY</h4>
          <p>
            GARLAS coordinates transport through certified land and ocean
            carriers but never takes physical possession of the vehicle.
            Responsibility for loss or delay lies with the carrier or shipping
            line executing the transport. Ocean shipments are also subject to
            the carrier's Bill of Lading terms. Pickup and delivery dates are
            estimated and not guaranteed.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>3. CUSTOMER RESPONSIBILITIES</h4>
          <p>
            The customer must provide accurate vehicle information, prepare the
            vehicle properly, submit valid documentation, be present or appoint
            a representative at pickup and delivery, inspect and sign the Bill
            of Lading, and report any claims within 48 hours after delivery.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>4. INOPERABLE AND MODIFIED VEHICLES</h4>
          <p>
            Vehicles that are inoperable or modified must be disclosed at the
            time of booking. Oversized or altered vehicles may incur extra
            charges or be rejected. If a running vehicle becomes inoperable
            during handling or transport, the customer will be responsible for
            additional winch or special handling fees.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>5. PERSONAL ITEMS AND PROHIBITED ARTICLES</h4>
          <p>
            No personal items are allowed inside the vehicle (only
            factory-installed accessories). Firearms, flammable liquids, drugs,
            money, and documents are prohibited. Any undeclared items travel at
            the customer's sole risk and may cause the vehicle to be held by
            port or customs authorities.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>6. CANCELLATIONS AND REFUNDS</h4>
          <p>
            Cancellations before carrier assignment: no fee. After assignment or
            dispatch: $150 USD minimum administrative fee. If the vehicle has
            been loaded or handed to the carrier, additional charges may apply.
            Cancellations must be submitted via email to
            info@shipshippersusa.com. Phone or chat cancellations will not be
            accepted.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>7. PAYMENTS AND CHARGES</h4>
          <p>
            All payments must be completed in full prior to shipment or as
            stated on the order confirmation. C.O.D. payments must be made in
            cash, money order, or cashier's check—personal checks or cards are
            not accepted. Vehicles may be stored at the customer's expense if
            delivery is refused or payment is incomplete. Late invoices accrue
            1.5% monthly interest.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>8. INSURANCE</h4>
          <p>
            Domestic USA: insurance included (FMCSA). | USA↔Puerto Rico:
            optional $100 (25k) / $200 (50k) with $1,000 deductible. |
            USA→Central America: not available. GARLAS recommends optional
            maritime insurance for vehicles valued over $15,000 USD.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>9. CLAIMS FOR LOSS, DAMAGE OR DELAY</h4>
          <p>
            GARLAS is not liable for damage or loss. Claims must be filed
            directly with the carrier or shipping line in accordance with
            applicable laws (Carmack Amendment or Carriage of Goods by Sea Act).
            GARLAS will assist in providing carrier details upon request.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>10. LIMITATION OF LIABILITY</h4>
          <p>
            The maximum liability of GARLAS for any claim shall not exceed the
            service fees paid for brokerage services. GARLAS does not guarantee
            delivery times, profit, or future market conditions.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>11. INDEMNIFICATION</h4>
          <p>
            The customer agrees to indemnify and hold GARLAS harmless from any
            claims, fines, or losses arising from false information, legal
            violations, or damages caused by unauthorized or unreported items.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>12. GOVERNING LAW AND JURISDICTION</h4>
          <p>
            This agreement is governed by the laws of the State of Florida, USA.
            Any disputes shall be resolved in the courts of Miami-Dade County
            unless arbitration is mutually agreed. For Puerto Rico or Central
            America operations, local maritime laws apply.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>13. CONTRACTUAL RELATIONSHIP</h4>
          <p>
            Nothing in this agreement constitutes partnership, employment, or
            agency. GARLAS and the customer act as independent entities. These
            Terms supersede all prior agreements.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>14. IMAGE AND PROMOTIONAL RIGHTS</h4>
          <p>
            GARLAS may use the client's name or logo as a commercial reference
            unless the client opts out by emailing privacy@shipshippersusa.com.
          </p>
        </Card>

        <Card className=" py-4 px-3 text-green"></Card>
      </div>
      <div
        className="bg-green-light-cu-2 text-green py-4 padding"
        style={{ minHeight: "200px" }}
      >
        <h4 style={{ fontWeight: "600" }}>LEGAL SUMMARY</h4>
        <p>
          GARLAS LLC acts as a licensed intermediary, not a carrier. Delivery
          times are estimates, cancellations generate administrative fees,
          maritime insurance is optional, and claims must be filed directly with
          the carrier or shipping line.
        </p>
      </div>
    </>
  );
};

export default EnglishTerms;
